import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { formatPrice } from '@olo-web/domain/orders/functions/formatPrice';

interface IProps {
  amount: string | number;
  label: string;
  isBolded?: boolean;
}

export const LineItem = ({ amount, label, isBolded = false }: IProps) => {
  return (
    <Flex
      justifyContent="space-between"
      fontWeight={isBolded ? 600 : 400}
      width="100%"
      fontSize="sm"
    >
      <Text>{label}</Text>
      <Text>{formatPrice(amount)}</Text>
    </Flex>
  );
};
